// @flow

import { type Room } from 'types/room'
import { roomName } from 'frontend_core/dist/helpers/format'

export default class RoomPagePresenter {
  room: ?Room

  constructor(room?: Room) {
    this.room = room
  }

  setRoom = (room: Room) => {
    this.room = room
  }

  getThumbnails = () => {
    if (!this.room) return []

    const thumbnails = [].concat(
      // thumbnails.results を Array<{ url, description, roomName }> ハッシュにする
      (this.room.thumbnails.results || []).map(t => ({
        url: t.url,
        description: t.description,
        roomName: roomName(this.room),
      })),
      // optionItems.results.thumbnails.results を Array<{ url, description, roomName }> にする
      ...(this.room.optionItems.results || [])
        .filter(o => (o.thumbnails.results || []).length > 0)
        .map(o =>
          (o.thumbnails.results || []).map(optionThumbs => ({
            url: optionThumbs.url,
            description: optionThumbs.description,
            roomName: roomName(this.room),
          })),
        ),
    )
    return thumbnails
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/RoomPage/RoomPagePresenter.js